import ApiService from "@/core/services/api.service";

const actions = {
  /**
   *
   * @param context
   * @param payload
   * @returns {*}
   */
  removeEmployeeAdminRole(context, payload) {
    ApiService.setHeader();
    return ApiService.post("employee/privilege/remove", payload).then(
      (response) => response
    );
  },
};

export default {
  actions,
};
